import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line hero reveal
export const MaskedLines = ({ lines, className = "" }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.9, delay: 0.15 + i * 0.14, ease: [0.16, 1, 0.3, 1] }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </div>
);

export const Counter = ({ value, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!inView) return;
    const match = String(value).match(/(\d+)/);
    if (!match) { setDisplay(value); return; }
    const target = parseInt(match[1], 10);
    const prefix = String(value).slice(0, match.index);
    const suffix = String(value).slice(match.index + match[1].length);
    let start = 0;
    const dur = 1400;
    const t0 = performance.now();
    const step = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      start = Math.round(eased * target);
      setDisplay(`${prefix}${start}${suffix}`);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [inView, value]);

  return <span ref={ref} className={className}>{display}</span>;
};

export const Overline = ({ children, dark = false }) => (
  <span className={`inline-flex items-center gap-2 text-xs md:text-sm uppercase tracking-[0.22em] font-semibold ${dark ? "text-[#1EA7E1]" : "text-[#1261A0]"}`}>
    <span className="h-px w-8 bg-[#F28C28]" />
    {children}
  </span>
);
